export default {
  'nav.catalog': 'Katalog', 'nav.live': 'Kelas Langsung', 'nav.qa': 'Tanya Pakar',
  'nav.consult': 'Konsultasi', 'nav.providers': 'Penyedia', 'nav.myLearning': 'Pembelajaran Saya',
  'nav.certificates': 'Sertifikat', 'nav.orders': 'Transaksi', 'nav.bookings': 'Jadual Saya',
  'nav.admin': 'Portal Admin', 'nav.verify': 'Sahkan Sertifikat',
  'auth.login': 'Masuk', 'auth.loginWith': 'Masuk dengan The Muslim', 'auth.logout': 'Keluar',
  'auth.subtitle': 'Guna akaun The Muslim anda — tiada pendaftaran berasingan.',
  'auth.ssoContinue': 'Teruskan dengan The Muslim',
  'auth.ssoHint': 'Anda akan dibawa ke halaman The Muslim. Belum ada akaun? Boleh daftar di sana.',
  'auth.cbWorking': 'Menyelesaikan log masuk…',
  'auth.cbFailed': 'Log masuk tidak selesai',
  'auth.cbMissing': 'Pautan kembali tidak lengkap. Sila masuk semula.',
  'auth.cbHome': 'Ke laman utama',
  'hero.eyebrow': 'Menghubungkan orang awam dengan pakar yang sahih',
  'hero.title': 'Belajar terus daripada pakar yang disahkan',
  'hero.sub': 'E-kursus berstruktur, kelas langsung, tanya pakar dan konsultasi peribadi — satu tempat.',
  'hero.cta': 'Lihat katalog', 'hero.cta2': 'Kelas percuma',
  'stat.learners': 'pelajar', 'stat.courses': 'kursus terbit', 'stat.experts': 'pakar disahkan', 'stat.certificates': 'sertifikat terbit',
  'home.categories': 'Cari mengikut bidang', 'home.popular': 'Paling popular', 'home.featured': 'Pilihan kurator',
  'home.free': 'Mula percuma', 'home.providers': 'Penyedia rakan', 'home.experts': 'Pakar disahkan',
  'home.live': 'Langsung & akan datang', 'home.seeAll': 'Lihat semua',
  'home.trust1': 'Pakar sahih & disahkan', 'home.trust1d': 'Setiap pakar melalui pengesahan kredensial.',
  'home.trust2': 'Mudah diakses', 'home.trust2d': 'Tanya terus kepada ahlinya, tanpa susah.',
  'home.trust3': 'Jawapan dipercayai', 'home.trust3d': 'Rujukan daripada pakar bidang, bukan sekadar pendapat.',
  'catalog.title': 'Katalog kursus', 'catalog.filters': 'Penapis', 'catalog.reset': 'Set semula',
  'catalog.results': 'kursus ditemui', 'catalog.sort': 'Susun', 'catalog.search': 'Cari kursus, pakar atau topik',
  'level.beginner': 'Permulaan', 'level.intermediate': 'Pertengahan', 'level.advanced': 'Lanjutan', 'level.expert': 'Lanjutan', 'level.all': 'Semua tahap',
  'price.free': 'Percuma', 'price.paid': 'Berbayar',
  'course.enroll': 'Daftar sekarang', 'course.enrollFree': 'Sertai percuma', 'course.continue': 'Sambung belajar',
  'course.curriculum': 'Silibus', 'course.reviews': 'Ulasan', 'learn.title': 'Pembelajaran Saya',
  'cert.title': 'Sertifikat Saya', 'qa.title': 'Tanya Pakar', 'live.title': 'Kelas Langsung',
  'consult.title': 'Konsultasi 1-on-1', 'ui.loading': 'Memuatkan…', 'ui.retry': 'Cuba lagi',
  'ui.empty': 'Tiada data', 'ui.verified': 'Disahkan', 'ui.comingSoon': 'Akan Datang',
  'filter.category': 'Bidang', 'filter.level': 'Tahap', 'filter.price': 'Harga', 'filter.rating': 'Penilaian',
  'filter.language': 'Bahasa', 'filter.features': 'Ciri', 'filter.provider': 'Penyedia',
  'sort.most_popular': 'Paling popular', 'sort.highest_rated': 'Penilaian tertinggi', 'sort.newest': 'Terbaharu',
  'sort.price_low': 'Harga terendah', 'sort.price_high': 'Harga tertinggi',
  'feat.certificate': 'Sertifikat', 'feat.quiz': 'Kuiz', 'feat.live': 'Sesi langsung',
  'course.buy': 'Beli kursus', 'course.preview': 'Pratonton percuma', 'course.objectives': 'Apa yang anda akan kuasai',
  'course.requirements': 'Yang perlu disediakan', 'course.audience': 'Untuk siapa', 'course.about': 'Tentang kursus',
  'course.instructor': 'Pengajar', 'course.related': 'Kursus serupa', 'course.lessons': 'pelajaran', 'course.modules': 'modul',
  'course.includes': 'Termasuk', 'course.lifetime': 'Akses selamanya', 'course.expiry': 'Akses {n} hari',
  'course.enrolled': '{n} pelajar', 'course.lastUpdate': 'Dikemas kini {d}', 'course.locked': 'Terkunci',
  'checkout.title': 'Ringkasan pesanan', 'checkout.coupon': 'Kod kupon', 'checkout.apply': 'Guna',
  'checkout.pay': 'Bayar sekarang', 'checkout.method': 'Kaedah pembayaran', 'checkout.total': 'Jumlah bayar',
  'checkout.subtotal': 'Subjumlah', 'checkout.discount': 'Diskaun', 'checkout.simulate': 'Simulasi Midtrans Snap',
  'checkout.success': 'Pembayaran berjaya', 'checkout.startLearning': 'Mula belajar',
  'learn.inProgress': 'Sedang berjalan', 'learn.completed': 'Selesai', 'learn.notStarted': 'Belum bermula',
  'learn.resume': 'Sambung', 'learn.progress': '{n}% selesai',
  'player.next': 'Pelajaran seterusnya', 'player.prev': 'Sebelumnya', 'player.complete': 'Tanda selesai',
  'player.previewNote': 'Anda sedang mencuba kelas ini secara percuma. Pelajaran lain terbuka selepas mendaftar.', 'player.previewCta': 'Lihat kelas', 'player.otherLang': 'Video dalam bahasa {lang}',
  'player.notes': 'Nota', 'player.resources': 'Bahan', 'player.transcript': 'Transkrip', 'player.discussion': 'Perbincangan',
  'player.speed': 'Kelajuan', 'player.captions': 'Sari kata', 'player.resume': 'Sambung dari {t}',
  // --- ruang belajar (/learn) ---
  'player.exit': 'Keluar', 'player.lessonOf': 'Pelajaran {n} daripada {total}',
  'player.remaining': 'Baki {t}', 'player.shortcutHint': 'space jeda · ←→ 5 saat · J/L 10 saat · F skrin penuh',
  'player.videoMissing': 'Video pelajaran ini belum dimuat naik.',
  'player.videoBroken': 'Video pelajaran ini ada, tetapi pautannya gagal dibuat. Cuba muat semula halaman.',
  'player.tamper': 'Lapisan penanda pemilik telah dibuang, jadi main balik dihentikan. Muat semula halaman untuk menonton lagi.',
  'player.throttled': 'Terlalu banyak permintaan video daripada akaun ini dalam satu jam. Cuba lagi sebentar lagi.',
  'player.linkDead': 'Pautan video tidak dapat diperbaharui. Semak sambungan anda, kemudian muat semula halaman.',
  'player.nextUp': 'Seterusnya', 'player.lastLesson': 'Ini pelajaran terakhir.', 'player.replay': 'Ulang',
  'player.markedDone': 'Pelajaran ditanda selesai',
  'player.liveNote': 'Sesi langsung untuk peserta kelas ini. Pautan aktif 10 minit sebelum jadual.',
  'player.liveCta': 'Lihat jadual langsung',
  'player.noteAdd': 'Simpan nota', 'player.notePlaceholder': 'Tulis nota anda untuk pelajaran ini…',
  'player.notePlaceholderAt': 'Tulis nota untuk minit {t}…',
  'player.notesEmpty': 'Belum ada nota. Apa yang anda tulis di sini disimpan dalam akaun anda, jadi ia kekal apabila dibuka dari peranti lain.',
  'player.notesLoginTitle': 'Nota disimpan dalam akaun anda',
  'player.notesLoginHint': 'Log masuk dahulu supaya nota anda tidak hilang apabila bertukar peranti.',
  'player.jumpTo': 'Lompat ke minit ini',
  'player.resourcesEmpty': 'Tiada bahan muat turun untuk pelajaran ini.',
  'player.download': 'Muat turun', 'player.linkFailed': 'Pautan gagal dibuat',
  'player.courseDone': 'Kelas selesai! 🎉',
  'player.courseDoneNote': 'Sijil anda telah dikeluarkan dan boleh disahkan secara awam melalui kod unik.',
  'player.viewCert': 'Lihat sijil',
  'ui.edit': 'Ubah', 'ui.delete': 'Padam',
  'adm.res.title': 'Bahan muat turun', 'adm.res.add': 'Tambah bahan',
  'adm.res.added': 'Bahan ditambah',
  'adm.res.tooBig': 'Saiz fail maksimum 25 MB.',
  'adm.res.hint': 'Lampirkan slaid, lembaran kerja, atau ringkasan. PDF atau imej, maksimum 25 MB. Eksport slaid ke PDF dahulu.',
  'quiz.start': 'Mula kuiz', 'quiz.submit': 'Hantar', 'quiz.retry': 'Cuba lagi',
  'quiz.passed': 'Lulus', 'quiz.failed': 'Belum lulus', 'quiz.score': 'Markah', 'quiz.attempt': 'Percubaan {n}',
  'cert.download': 'Muat turun PDF', 'cert.share': 'Kongsi ke LinkedIn', 'cert.verify': 'Sahkan',
  'cert.serial': 'Nombor siri', 'cert.issued': 'Dikeluarkan',
  'cert.valid': 'Sertifikat ini sah dan terakam', 'cert.invalid': 'Sertifikat tidak dijumpai',
  'cert.verifyTitle': 'Sahkan sertifikat', 'cert.verifyHint': 'Masukkan kod pengesahan yang tercetak pada sertifikat',
  'qa.ask': 'Ajukan soalan', 'qa.answered': 'Dijawab', 'qa.open': 'Menunggu jawapan',
  'qa.yourQuestion': 'Soalan anda', 'qa.detail': 'Butiran soalan', 'qa.send': 'Hantar soalan',
  'qa.sub': 'Hantar soalan kepada pakar disahkan. Percuma dalam v1 — jawapan terbuka kepada umum agar bermanfaat kepada yang lain.',
  'qa.field': 'Bidang', 'qa.askWho': 'Tanya siapa', 'qa.anyExpert': 'Mana-mana pakar dalam bidang ini',
  'qa.askWhoHint': 'Biarkan kosong jika tidak ditujukan kepada pakar tertentu — soalan terbuka biasanya lebih cepat dijawab.',
  'qa.field.title': 'Soalan ringkas', 'qa.field.titlePh': 'Contoh: Apakah hukum…?',
  'qa.field.body': 'Penjelasan', 'qa.field.bodyHint': 'Semakin terperinci, semakin tepat jawapannya',
  'qa.publicNote': 'Soalan yang dijawab akan dipaparkan secara umum tanpa data peribadi anda.',
  'qa.sent': 'Soalan dihantar — pakar akan menjawab dalam 1–3 hari bekerja.',
  'live.now': 'Sedang langsung', 'live.upcoming': 'Akan datang', 'live.ended': 'Tamat',
  'live.join': 'Sertai kelas', 'live.remind': 'Ingatkan saya', 'live.reminded': 'Peringatan aktif', 'live.viewers': '{n} menonton',
  'consult.book': 'Pilih slot', 'consult.slots': '{n} slot tersedia', 'consult.from': 'Dari',
  'consult.confirm': 'Sahkan tempahan', 'consult.notes': 'Ceritakan ringkas keperluan anda',
  'admin.dashboard': 'Papan Pemuka', 'admin.guide': 'Panduan', 'admin.courses': 'Kursus', 'admin.instructors': 'Pakar',
  'admin.live': 'Kelas Langsung', 'admin.qa': 'Tanya Pakar', 'admin.consult': 'Konsultasi',
  'admin.enrollments': 'Pendaftaran', 'admin.reviews': 'Ulasan', 'admin.earnings': 'Pendapatan',
  'admin.slots': 'Slot Konsultasi', 'admin.certificates': 'Sertifikat', 'admin.coupons': 'Kupon',
  'admin.notifications': 'Pemberitahuan', 'admin.certTemplates': 'Templat Sertifikat', 'admin.audit': 'Log Audit',
  'admin.providers': 'Penyedia', 'admin.categories': 'Kategori', 'admin.payouts': 'Pembayaran',
  'admin.platformOnly': 'Khusus platform', 'admin.approvalQueue': 'Menunggu kurasi',
  'admin.selected': '{n} dipilih', 'admin.approve': 'Luluskan', 'admin.reject': 'Tolak', 'admin.archive': 'Arkibkan',
  'admin.bulk': 'Tindakan pukal', 'admin.newCourse': 'Kursus baharu', 'admin.editCurriculum': 'Atur kurikulum',
  'status.draft': 'Draf', 'status.pending_review': 'Menunggu kurasi', 'status.published': 'Terbit',
  'status.rejected': 'Ditolak', 'status.archived': 'Diarkibkan', 'status.active': 'Aktif', 'status.completed': 'Selesai',
  'status.paid': 'Dibayar', 'status.pending': 'Tertunda', 'status.failed': 'Gagal', 'status.held': 'Ditahan',
  'status.payable': 'Sedia bayar', 'status.processing': 'Diproses',
  'ui.error': 'Ada yang tidak kena', 'ui.emptyHint': 'Cuba ubah penapis atau kata kunci.',
  'ui.save': 'Simpan', 'ui.cancel': 'Batal', 'ui.close': 'Tutup', 'ui.search': 'Cari',
  'ui.all': 'Semua', 'ui.page': 'Halaman', 'ui.of': 'daripada', 'ui.viewMode': 'Paparan', 'ui.design': 'Varian reka bentuk',

  // ---- portal admin: label yang dipakai merentas halaman ----
  // Dikumpulkan supaya lajur "Status"/"Pakar"/"Harga" yang muncul di belasan
  // jadual tidak menjadi belasan kunci yang perlu diterjemah satu per satu.
  'adm.col.actions': 'Tindakan', 'adm.col.provider': 'Penyedia', 'adm.col.instructor': 'Pakar',
  'adm.col.status': 'Status', 'adm.col.price': 'Harga', 'adm.col.students': 'Peserta',
  'adm.col.no': 'No.',
  'adm.col.course': 'Kursus', 'adm.col.schedule': 'Jadual', 'adm.col.time': 'Masa',
  'adm.col.duration': 'Tempoh', 'adm.col.field': 'Bidang', 'adm.col.updated': 'Dikemas kini',
  'adm.col.notes': 'Catatan', 'adm.col.position': 'Urutan', 'adm.col.key': 'Key',
  'adm.col.score': 'Markah', 'adm.col.scope': 'Skop',
  'adm.table.clear': 'bersihkan',
  'adm.val.inactive': 'Tidak aktif', 'adm.val.platform': 'Platform', 'adm.val.default': 'Default',
  'adm.val.pending': 'Menunggu', 'adm.val.notYet': 'Belum', 'adm.val.yes': 'Ya',
  'adm.val.minutes': '{n} min',
  'adm.lang.id': 'Indonesia', 'adm.lang.en': 'English', 'adm.lang.ms': 'Melayu', 'adm.lang.ar': 'Arab',
  'adm.field.category': 'Kategori', 'adm.field.priceIdr': 'Harga (IDR)', 'adm.field.logo': 'Logo',
  'adm.field.accentColor': 'Warna aksen (hex)',
  'adm.field.providerHint': 'Admin penyedia automatik menggunakan institusinya sendiri.',
  'adm.bulk.activate': 'Aktifkan', 'adm.bulk.deactivate': 'Nyahaktifkan',
  'adm.bulk.markComplete': 'Tandakan selesai', 'adm.bulk.approvePublish': 'Luluskan & terbitkan',
  'adm.bulk.unpublish': 'Jadikan draf',
  'adm.bulk.updated': '{n} baris dikemas kini', 'adm.bulk.rejected': '{n} baris ditolak',
  'adm.filter.all': '{field}: Semua',

  // ---- portal admin: borang generik (ResourcePage) ----
  'adm.form.required': '{field} wajib diisi', 'adm.form.selectField': '— Pilih {field} —',
  'adm.form.optionsFailed': 'Gagal memuatkan pilihan', 'adm.form.saved': 'Perubahan disimpan',
  'adm.form.created': 'Berjaya ditambah', 'adm.form.saveFailed': 'Gagal menyimpan',
  'adm.form.deleted': 'Data dipadam', 'adm.form.deleteFailed': 'Gagal memadam',
  'adm.form.edit': 'Edit', 'adm.form.add': 'Tambah', 'adm.form.delete': 'Padam',
  'adm.form.deleteTitle': 'Sahkan padam',
  'adm.form.deleteDefault': 'Padam data ini? Tindakan ini boleh dibatalkan melalui DB (soft delete).',
  'adm.reject.title': 'Sebab penolakan', 'adm.reject.confirmN': 'Tolak {n} kursus',
  'adm.reject.note': 'Sebab dihantar kepada penyedia dan dipaparkan di portal mereka. Jelaskan apa yang perlu diperbaiki.',
  'adm.reject.ph': 'Cth. audio modul 2 pecah pada minit 04:12 — mohon rakam semula.',

  // ---- portal admin: kursus ----
  'adm.courses.sub': 'Kurasi, terbitkan dan atur kurikulum kursus.',
  'adm.courses.add': 'Tambah Kursus', 'adm.courses.createTitle': 'Tambah Kursus Baharu',
  'adm.courses.createdMsg': 'Kursus dibuat sebagai draf — lengkapkan kurikulum kemudian hantar untuk kurasi.',
  'adm.courses.formSub': 'Bina rangka kursus dahulu (status draf). Kurikulum, modul, kuiz & harga terperinci diatur dalam editor kursus.',
  'adm.courses.newCourseToast': 'Borang kursus baharu: POST /admin/courses',
  'adm.courses.field.title': 'Tajuk kursus', 'adm.courses.field.titlePh': 'cth. Tahsin Al-Qur’an untuk Permulaan',
  'adm.courses.field.subtitle': 'Subtajuk', 'adm.courses.field.subtitlePh': 'Dipaparkan pada kad & hero',
  'adm.courses.field.instructor': 'Pakar pengajar',
  'adm.courses.field.instructorHint': 'Mesti pakar daripada penyedia yang sama.',
  'adm.courses.field.categoryHint': 'Biarkan kosong untuk ikut bidang pakar.',
  'adm.courses.field.isFree': 'Kursus percuma',
  'adm.courses.field.minutes': 'Anggaran tempoh (minit)',
  'adm.courses.field.desc': 'Penerangan ringkas', 'adm.courses.field.descPh': 'Ringkaskan isi & manfaat kursus…',
  'adm.courses.lessonModules': '{l} pelajaran · {m} modul',
  'adm.courses.manage': 'Urus',

  // ---- portal admin: pakar ----
  'adm.instructors.sub': 'Sahkan kredensial pakar — nilai jual utama platform.',
  'adm.instructors.add': 'Tambah Pakar', 'adm.instructors.createTitle': 'Tambah Pakar Baharu',
  'adm.instructors.editTitle': 'Edit Pakar',
  'adm.instructors.formSub': 'Isi profil pakar. Bidang & penyedia menentukan di mana pakar dipaparkan.',
  'adm.instructors.deleteConfirm': 'Padam pakar "{name}"? Data disembunyikan (soft delete), boleh dipulihkan melalui DB.',
  'adm.instructors.field.avatar': 'Foto profil',
  'adm.instructors.field.name': 'Nama penuh', 'adm.instructors.field.namePh': 'cth. Ustaz Ahmad Fauzi, Lc.',
  'adm.instructors.field.headline': 'Headline', 'adm.instructors.field.headlinePh': 'Pakar Tajwid & Qiraat Sab’ah',
  'adm.instructors.field.category': 'Bidang kepakaran',
  'adm.instructors.field.bio': 'Bio ringkas',
  'adm.instructors.field.bioPh': 'Latar belakang, pengalaman mengajar, dan pendekatan bahan…',
  'adm.instructors.field.verified': 'Tandakan disahkan',
  'adm.instructors.filterVerified': 'Pengesahan', 'adm.instructors.unverify': 'Tarik balik pengesahan',
  'adm.i18n.sectionTitle': 'Teks berbilang bahasa',
  'adm.i18n.sectionHint': 'Hanya isi kotak ini yang ada versi mengikut bahasa. Gambar, nama, dan ruangan di atas cuma satu.',
  'adm.i18n.sourceLang': 'Bahasa asal tulisan',
  'adm.i18n.sourceHint': 'Bahasa yang anda guna menulis di ruangan bawah. Terjemahan dibuat daripada ini, jadi pastikan ia betul.',
  'adm.i18n.sourceBadge': '(asal)',
  'adm.i18n.translate': 'Terjemah dengan AI',
  'adm.i18n.saveFirst': 'Simpan dahulu, kemudian baru boleh diterjemah.',
  'adm.i18n.translateTo': 'Terjemah ke {lang} dengan AI',
  'adm.i18n.pickTab': 'Pilih tab bahasa sasaran dahulu.',
  'adm.i18n.done': 'Terjemahan selesai.',
  'adm.i18n.failed': 'Terjemahan gagal. Cuba lagi sebentar lagi.',
  'adm.i18n.partial': 'Sebahagian bahasa gagal diterjemah. Cuba lagi untuk yang masih kosong.',
  'adm.i18n.nothing': 'Tiada yang perlu diterjemah — semuanya sudah terisi.',
  'adm.i18n.fromAI': 'Hasil AI — sila semak dan betulkan jika perlu.',
  'adm.i18n.edited': 'Telah disunting sendiri. Tidak akan ditulis ganti oleh terjemahan semula.',
  'adm.i18n.empty': 'Belum diterjemah. Kosong bermakna teks asal yang dipaparkan.',
  'adm.instructors.field.accountEmail': 'Akaun log masuk (e-mel)',
  'adm.instructors.field.accountEmailPh': 'alamat@kampus.edu.my',
  'adm.instructors.account.hintNew': 'Isi untuk membuat akaun. Pakar kemudian mendaftar di The Muslim dengan alamat yang sama.',
  'adm.instructors.account.hintNone': 'Belum ada akaun — pakar ini belum boleh log masuk. Isi e-melnya untuk membuat akaun.',
  'adm.instructors.account.hintWaiting': 'Akaun sudah dibuat. Pakar tinggal mendaftar di The Muslim dengan alamat ini, kemudian sahkan e-melnya.',
  'adm.instructors.account.hintLinked': 'Sudah pernah log masuk. Mengosongkan ruangan ini tidak memutuskan apa-apa.',
  'adm.instructors.account.hintMissing': 'Pautan tergantung: akaunnya sudah tiada. Isi e-mel baharu untuk menyambung semula.',
  'adm.instructors.col.account': 'Akaun',
  'adm.instructors.account.none': 'Tiada akaun',
  'adm.instructors.account.waiting': 'Menunggu pendaftaran',
  'adm.instructors.account.linked': 'Aktif',
  'adm.instructors.account.missing': 'Pautan rosak',
  'adm.instructors.col.credentials': 'Kredensial',

  // ---- portal admin: kelas langsung ----
  'adm.live.sub': 'Jadualkan sesi LiveKit, pantau penonton.',
  'adm.live.col.session': 'Sesi', 'adm.live.col.viewers': 'Penonton',
  'adm.live.col.ticket': 'Tiket', 'adm.live.col.room': 'Room',

  // ---- portal admin: tanya pakar ----
  'adm.qa.sub': 'Barisan soalan yang menunggu jawapan pakar.',
  'adm.qa.col.question': 'Soalan', 'adm.qa.col.addressed': 'Ditujukan',
  'adm.qa.col.received': 'Masuk', 'adm.qa.col.answers': 'Jawapan',
  'adm.qa.answerTitle': 'Jawab soalan', 'adm.qa.answerSend': 'Hantar jawapan',
  'adm.qa.answerSent': 'Jawapan dihantar', 'adm.qa.answerLabel': 'Jawapan pakar',
  'adm.qa.answerPh': 'Tulis jawapan dengan rujukan yang boleh disahkan…',
  'adm.qa.answerNote': 'Jawapan terus dipaparkan kepada umum dan mencetuskan pemberitahuan kepada penanya.',

  // ---- portal admin: konsultasi & pendaftaran ----
  'adm.consult.sub': 'Tempahan sesi 1-on-1 dan statusnya.',
  'adm.consult.confirm': 'Sahkan', 'adm.consult.cancel': 'Batalkan',
  'adm.enroll.sub': 'Siapa belajar apa, sejauh mana.',
  'adm.enroll.reactivate': 'Aktifkan semula', 'adm.enroll.revoke': 'Tarik balik akses',
  'adm.enroll.col.source': 'Sumber', 'adm.enroll.col.progress': 'Kemajuan',
  'adm.enroll.col.enrolledAt': 'Didaftarkan',

  // ---- portal admin: ulasan ----
  'adm.reviews.sub': 'Moderasi ulasan; sembunyikan yang melanggar.',
  'adm.reviews.filterStars': 'Bintang', 'adm.reviews.hide': 'Sembunyikan', 'adm.reviews.show': 'Papar',
  'adm.reviews.col.author': 'Penulis', 'adm.reviews.col.text': 'Ulasan',

  // ---- portal admin: penyedia ----
  'adm.providers.sub': 'Tenant yang menjual kursus. Khusus platform.',
  'adm.providers.add': 'Tambah Penyedia', 'adm.providers.createTitle': 'Tambah Penyedia Baharu',
  'adm.providers.editTitle': 'Edit Penyedia',
  'adm.providers.formSub': 'Onboard institusi/syarikat baharu sebagai penjual kursus. Slug dijana automatik daripada nama.',
  'adm.providers.field.cover': 'Sampul',
  'adm.providers.field.name': 'Nama penyedia', 'adm.providers.field.namePh': 'cth. Rumah Tahfiz Nusantara',
  'adm.providers.field.desc': 'Penerangan', 'adm.providers.field.descPh': 'Profil ringkas institusi…',
  'adm.providers.field.website': 'Laman web', 'adm.providers.field.email': 'E-mel hubungan',
  'adm.providers.field.emailPh': 'admin@institusi.my',
  'adm.providers.field.share': 'Bagi hasil penyedia (%)',
  'adm.providers.field.shareHint': 'Bahagian penyedia daripada harga; bakinya untuk platform.',
  'adm.providers.field.locale': 'Locale lalai',
  'adm.providers.verify': 'Sahkan',
  'adm.providers.col.share': 'Bagi hasil', 'adm.providers.col.locale': 'Locale',

  // ---- portal admin: kategori ----
  'adm.categories.sub': 'Taksonomi peringkat platform (15 bidang).',
  'adm.categories.add': 'Tambah Kategori', 'adm.categories.editTitle': 'Edit Kategori',
  'adm.categories.formSub': 'Bidang kepakaran platform. Key digunakan dalam URL & penapis — biarkan kosong untuk auto daripada nama.',
  'adm.categories.deleteConfirm': 'Padam kategori "{name}"? Disembunyikan (soft delete).',
  'adm.categories.field.nameId': 'Nama (Indonesia)', 'adm.categories.field.nameIdPh': 'cth. Tahsin & Tajwid',
  'adm.categories.field.nameEn': 'Nama (English)', 'adm.categories.field.nameMs': 'Nama (Melayu)',
  'adm.categories.field.nameAr': 'Nama (Arab)',
  'adm.categories.field.keyPh': 'tahsin-tajwid (pilihan)',
  'adm.categories.field.keyHint': 'Slug unik; auto daripada nama jika kosong.',
  'adm.categories.field.icon': 'Ikon (Material Symbols)',
  'adm.categories.col.accent': 'Accent',

  // ---- portal admin: tingkat harga ----
  // ---- portal admin: pembayaran ----
  'adm.payouts.sub': 'Pindahan bagi-hasil kepada penyedia mengikut tempoh.',
  'adm.payouts.markPaid': 'Tandakan sudah dibayar',
  'adm.payouts.col.period': 'Tempoh', 'adm.payouts.col.amount': 'Jumlah', 'adm.payouts.col.method': 'Kaedah',

  // ---- portal admin: kupon ----
  'adm.coupons.sub': 'Kod diskaun: peratusan / potongan tetap, had penggunaan, dan tempoh sah.',
  'adm.coupons.add': 'Tambah Kupon', 'adm.coupons.editTitle': 'Edit Kupon',
  'adm.coupons.formSub': 'Kod ditukar ke huruf besar secara automatik. Nilai = peratus (0–100) untuk jenis peratusan, atau rupiah untuk potongan tetap.',
  'adm.coupons.deleteConfirm': 'Padam kupon "{code}"? Disembunyikan (soft delete).',
  'adm.coupons.field.code': 'Kod kupon', 'adm.coupons.field.type': 'Jenis',
  'adm.coupons.type.percent': 'Peratusan (%)', 'adm.coupons.type.fixed': 'Potongan tetap (Rp)',
  'adm.coupons.field.value': 'Nilai',
  'adm.coupons.scope.all': 'Semua kursus', 'adm.coupons.scope.course': 'Kursus tertentu',
  'adm.coupons.scope.category': 'Kategori tertentu',
  'adm.coupons.field.maxUses': 'Maks. jumlah penggunaan', 'adm.coupons.field.maxUsesHint': '0 = tanpa had.',
  'adm.coupons.field.perUser': 'Maks. setiap pengguna',
  'adm.coupons.field.startsAt': 'Mula berkuat kuasa', 'adm.coupons.field.endsAt': 'Tamat',
  'adm.coupons.field.providerHint': 'Biarkan kosong untuk kupon seluruh platform.',
  'adm.coupons.col.code': 'Kod', 'adm.coupons.col.discount': 'Diskaun',
  'adm.coupons.col.used': 'Terpakai', 'adm.coupons.col.valid': 'Sah',

  // ---- portal admin: slot konsultasi ----
  'adm.slots.sub': 'Slot masa konsultasi 1-on-1 yang dibuka pakar untuk ditempah.',
  'adm.slots.add': 'Tambah Slot', 'adm.slots.createTitle': 'Buka Slot Konsultasi',
  'adm.slots.editTitle': 'Edit Slot',
  'adm.slots.formSub': 'Penyedia slot automatik mengikut penyedia pakar. Slot yang sudah ditempah tidak boleh dibuka semula di sini.',
  'adm.slots.deleteConfirm': 'Padam slot ini? Disembunyikan (soft delete).',
  'adm.slots.field.start': 'Masa mula', 'adm.slots.field.duration': 'Tempoh (minit)',
  'adm.slots.field.priceHint': '0 = percuma.',
  'adm.slots.open': 'Buka', 'adm.slots.col.booked': 'Tempahan',
  'adm.slots.booked': 'Ditempah', 'adm.slots.free': 'Kosong',

  // ---- portal admin: sertifikat ----
  'adm.certs.sub': 'Sertifikat yang telah diterbitkan; tarik balik atau terbitkan semula bila perlu.',
  'adm.certs.reissue': 'Terbitkan semula', 'adm.certs.revoke': 'Tarik balik',
  'adm.certs.col.issued': 'Terbit', 'adm.certs.col.code': 'Kod pengesahan',
  'adm.certTpl.sub': 'Reka bentuk sertifikat: logo, warna, tandatangan, dan teks isi.',
  'adm.certTpl.add': 'Tambah Templat', 'adm.certTpl.createTitle': 'Tambah Templat Sertifikat',
  'adm.certTpl.editTitle': 'Edit Templat',
  'adm.certTpl.formSub': 'Gunakan {student}, {course}, {date} dalam teks isi sebagai placeholder yang digantikan semasa penerbitan.',
  'adm.certTpl.deleteConfirm': 'Padam templat "{name}"? Disembunyikan (soft delete).',
  'adm.certTpl.field.name': 'Nama templat', 'adm.certTpl.field.namePh': 'cth. Sertifikat Tahsin 2026',
  'adm.certTpl.field.providerHint': 'Biarkan kosong untuk templat platform.',
  'adm.certTpl.field.orientation': 'Orientasi',
  'adm.certTpl.orientation.landscape': 'Landskap', 'adm.certTpl.orientation.portrait': 'Potret',
  'adm.certTpl.field.signature': 'Tandatangan',
  'adm.certTpl.field.signName': 'Nama penandatangan', 'adm.certTpl.field.signTitle': 'Jawatan penandatangan',
  'adm.certTpl.field.signNamePh': 'Ustaz Ahmad Fauzi, Lc.',
  'adm.certTpl.field.signTitlePh': 'Pengarah Akademik',
  'adm.certTpl.field.body': 'Teks isi',
  'adm.certTpl.field.bodyPh': 'Diberikan kepada {student} atas penyelesaian {course}…',
  'adm.certTpl.field.isDefault': 'Jadikan default',
  'adm.certTpl.col.template': 'Templat', 'adm.certTpl.col.signer': 'Penandatangan',

  // ---- portal admin: log audit ----
  'adm.audit.sub': 'Jejak tindakan admin (create/update/padam/broadcast). Sumber: activity log.',
  'adm.audit.col.action': 'Tindakan', 'adm.audit.col.actor': 'Oleh', 'adm.audit.col.detail': 'Butiran',

  // ---- editor kursus ----
  'adm.course.tabDetail': 'Detail', 'adm.course.tabPricing': 'Harga & akses',
  'adm.course.tabSettings': 'Sijil',
  'adm.course.viewPublic': 'Lihat paparan umum', 'adm.course.preview': 'Pratonton kandungan', 'adm.course.previewEmpty': 'Belum ada pelajaran untuk dipratonton', 'adm.course.submitReview': 'Hantar untuk kurasi',
  'adm.course.published': 'Kursus diterbitkan', 'adm.course.rejected': 'Kursus ditolak',
  'adm.course.rejectedBy': 'Ditolak kurator', 'adm.course.rejectBtn': 'Tolak kursus',
  'adm.course.rejectPh': 'Jelaskan apa yang perlu diperbaiki penyedia…',
  'adm.course.title': 'Tajuk', 'adm.course.estMinutes': 'Anggaran minit',
  'adm.course.spokenLang': 'Bahasa pengantar',
  'adm.course.spokenLangHint': 'Bahasa yang dituturkan pengajar dalam video. Tidak diterjemahkan.',
  'adm.course.descHtml': 'Penerangan (HTML)', 'adm.course.objectives': 'Objektif',
  'adm.course.addObjective': 'Tambah poin',
  'adm.course.objectivesHint': 'Apa yang pelajar boleh lakukan selepas tamat.',
  'adm.course.objectivesPh': 'Contoh: Menyusun rancangan sesi kaunseling untuk klien remaja',
  'adm.course.addRequirement': 'Tambah persediaan',
  'adm.course.requirementsHint': 'Barang atau bekalan yang perlu disediakan pelajar. Ini tidak mengunci kursus — yang mengunci ialah Prasyarat kursus di bawah ini.',
  'adm.course.requirementsPh': 'Contoh: Pernah mengikuti kelas asas kaunseling',
  'adm.course.addAudience': 'Tambah sasaran',
  'adm.course.audienceHint': 'Siapa yang paling sesuai mengikuti kursus ini.',
  'adm.course.audiencePh': 'Contoh: Guru bimbingan dan kaunseling di sekolah menengah',
  'adm.course.thumbnail': 'Thumbnail', 'adm.course.thumbHint': 'Nisbah 16:9, minimum 1280×720, maks 8 MB.',
  'adm.course.slug': 'Slug', 'adm.course.comparePrice': 'Harga perbandingan',
  'adm.course.accessType': 'Jenis akses', 'adm.course.access.lifetime': 'Selamanya',
  'adm.course.access.expiry': 'Luput N hari', 'adm.course.access.subscription': 'Langganan',
  'adm.course.accessDays': 'Akses (hari)',
  'adm.course.certOnComplete': 'Terbitkan sertifikat apabila selesai',
  'adm.course.completionRule': 'Syarat penyelesaian',
  'adm.course.completionRule1': '100% pelajaran selesai · kuiz akhir lulus (markah ≥ 70)',
  'adm.course.completionRule2': 'Video dikira selesai pada 90% tempoh (SCORM/cmi5: completion ≠ success).',

  // ---- editor kursus: kesediaan ----
  'adm.ready.title': 'Kesediaan kursus', 'adm.ready.count': '{n}/{total} siap',
  'adm.ready.live': 'Kursus ini tayang di storefront.',
  'adm.ready.waiting': 'Menunggu kurasi admin platform',
  'adm.ready.remaining': 'Lengkapkan {n} langkah lagi',
  'adm.ready.detail': 'Detail kursus', 'adm.ready.detailDone': 'Penerangan & objektif lengkap',
  'adm.ready.detailTodo': 'Isi penerangan + sekurang-kurangnya 1 objektif',
  'adm.ready.curriculum': 'Kurikulum',
  'adm.ready.curriculumTodo': 'Tambah sekurang-kurangnya 1 modul & 1 pelajaran',
  'adm.ready.quiz': 'Soalan kuiz', 'adm.ready.quizDone': 'Semua kuiz sudah ada soalan',
  'adm.ready.quizTodo': '{n} kuiz belum ada soalan',
  'adm.ready.priceTodo': 'Tetapkan harga atau tandakan percuma',

  // ---- editor kurikulum ----
  'adm.cur.loading': 'Memuatkan kurikulum…', 'adm.cur.saved': 'Kurikulum disimpan',
  'adm.cur.addModule': 'Tambah modul', 'adm.cur.addLesson': 'Tambah pelajaran',
  'adm.cur.moduleN': 'Modul {n}', 'adm.cur.newLesson': 'Pelajaran baharu',
  'adm.cur.count': '{m} modul · {l} pelajaran',
  'adm.cur.unsaved': 'Belum disimpan', 'adm.cur.save': 'Simpan kurikulum',
  'adm.cur.drip.none': 'Lepas: serta-merta', 'adm.cur.drip.days': 'Lepas: H+N', 'adm.cur.drip.date': 'Lepas: tarikh',
  'adm.cur.seconds': 'saat', 'adm.cur.preview': 'preview',
  'adm.cur.saveFirst': 'simpan dulu',
  'adm.cur.saveFirstHint': 'Simpan kurikulum dahulu supaya pelajaran mempunyai ID',
  'adm.a11y.moveUp': 'naik', 'adm.a11y.moveDown': 'turun', 'adm.a11y.delete': 'padam',

  // ---- editor kuiz ----
  'adm.quiz.title': 'Urus soalan · {lesson}', 'adm.quiz.save': 'Simpan kuiz', 'adm.quiz.saved': 'Kuiz disimpan',
  'adm.quiz.passing': 'Markah lulus (%)', 'adm.quiz.timeLimit': 'Had masa (minit)',
  'adm.quiz.maxAttempts': 'Maks percubaan',
  'adm.quiz.question': 'Soalan', 'adm.quiz.questionPh': 'Tulis soalan…',
  'adm.quiz.deleteQuestion': 'padam soalan', 'adm.quiz.deleteOption': 'padam pilihan',
  'adm.quiz.type': 'Jenis', 'adm.quiz.points': 'Poin',
  'adm.quiz.qtype.single': 'Pilihan tunggal', 'adm.quiz.qtype.multi': 'Pilihan berbilang (boleh >1 betul)',
  'adm.quiz.qtype.tf': 'Betul / Salah',
  'adm.quiz.options': 'Pilihan jawapan', 'adm.quiz.optionsHint': '(tandakan yang betul)',
  'adm.quiz.markCorrect': 'tandakan betul', 'adm.quiz.optionN': 'Pilihan {n}', 'adm.quiz.addOption': 'Tambah pilihan',
  'adm.quiz.explanation': 'Penjelasan (pilihan)', 'adm.quiz.explanationPh': 'Muncul selepas dijawab',
  'adm.quiz.addQuestion': 'Tambah soalan', 'adm.quiz.empty': 'Belum ada soalan. Klik “Tambah soalan”.',
  'adm.quiz.err.noText': 'Ada soalan tanpa teks soalan',
  'adm.quiz.err.minOptions': 'Setiap soalan perlu sekurang-kurangnya 2 pilihan jawapan',
  'adm.quiz.err.emptyOption': 'Ada pilihan jawapan kosong',
  'adm.quiz.err.noCorrect': 'Setiap soalan perlu sekurang-kurangnya 1 jawapan betul',

  // ---- papan pemuka admin ----
  'adm.dash.period': 'Tempoh {label}.', 'adm.dash.loading': 'Memuatkan ringkasan…', 'adm.dash.export': 'Export',
  'adm.dash.guideTitle': 'Baharu di sini? Mulakan dengan panduan.',
  'adm.dash.guideSub': 'Urutan mengisi kandungan, ruangan yang wajib, dan perangkap yang kerap menyebabkan kursus gagal dihantar.',
  'adm.dash.guideCta': 'Buka panduan',
  'adm.dash.enrollments': 'Pendaftaran',
  'adm.dash.lessonsDone': 'Pelajaran selesai (North Star)', 'adm.dash.lessonsHint': 'Penunjuk nilai pembelajaran sebenar',
  'adm.dash.certsIssued': 'Sertifikat terbit',
  'adm.dash.funnelTitle': 'Corong pembelian', 'adm.dash.funnelRange': '{first} → bayar',
  'adm.dash.funnelConversion': 'Penukaran akhir',
  'adm.dash.funnelNoVisits': 'Lawatan belum terakam bulan ini, jadi peratusan penukaran belum boleh dikira. Perakaman berjalan automatik sebaik sahaja ada pengunjung membuka katalog.',
  'adm.dash.funnelEmpty': 'Belum ada lawatan katalog bulan ini. Lawatan mula terakam sebaik sahaja ada yang membuka halaman kursus — lawatan admin sendiri sengaja tidak dikira.',
  'adm.dash.queueAll': 'Semua barisan', 'adm.dash.queueClean': 'Barisan bersih 🎉',
  'adm.dash.submitted': 'Dihantar {ago}', 'adm.dash.lessonCount': '{n} pelajaran', 'adm.dash.reviewCta': 'Tinjau',
  'adm.dash.topCourses': 'Kursus paling laris', 'adm.dash.enrollCount': '{n} pendaftaran',
  'adm.dash.topCoursesEmpty': 'Belum ada kursus yang mempunyai pendaftar. Senarai ini terisi sendiri sebaik sahaja kursus pertama diikuti seseorang.',
  'adm.dash.health': 'Kesihatan platform', 'adm.dash.payoutsWaiting': 'Pembayaran menunggu',
  'adm.dash.reviewsToCheck': 'Ulasan perlu ditinjau',
  'adm.dash.recentOrders': 'Pesanan terbaharu', 'adm.dash.orderNoItems': '(tanpa perincian item)',
  'adm.dash.ordersEmpty': 'Belum ada pesanan masuk.',
  'adm.dash.csv.metric': 'Metrik', 'adm.dash.csv.value': 'Nilai', 'adm.dash.csv.period': 'Tempoh',
  'adm.dash.csv.gmv': 'GMV', 'adm.dash.csv.lessonsDone': 'Pelajaran selesai',
  'adm.dash.csv.month': 'Bulan', 'adm.dash.csv.funnelStage': 'Tahap corong',
  'adm.dash.csv.count': 'Jumlah', 'adm.dash.csv.revenue': 'Pendapatan',

  // ---- kerangka portal admin ----
  'adm.gate.title': 'Portal Admin KnowledgeX',
  'adm.gate.sub': 'Masuk dengan akaun admin platform atau admin penyedia, menggunakan e-mel & kata laluan yang diberikan pasukan teknikal.',
  'adm.gate.login': 'Masuk sebagai admin', 'adm.gate.storefront': 'Ke storefront',
  'adm.role.platform': 'Admin platform', 'adm.role.provider': 'Admin penyedia',
  'adm.scope.all': 'Semua penyedia', 'adm.scope.provider': 'Skop: {name}',
  'adm.nav.storefront': 'Storefront',

  // ---- senarai langkah onboarding ----
  'adm.onb.fabTitle': 'Langkah awal untuk pakar baharu', 'adm.onb.fabLabel': 'Langkah awal — {n} langkah lagi',
  'adm.onb.fabTip': 'Langkah awal',
  'adm.onb.panelTitle': 'Mulakan di sini', 'adm.onb.checking': 'Memeriksa…',
  'adm.onb.progress': '{n} daripada {total} selesai',
  'adm.onb.doneTitle': 'Semua langkah selesai 🎉',
  'adm.onb.donePlatform': 'Katalog sudah mempunyai kursus yang tayang.',
  'adm.onb.doneProvider': 'Kursus anda sudah sampai ke peringkat kurasi.',
  'adm.onb.doneTail': 'Panduan lengkapnya tetap boleh dibuka bila-bila masa melalui menu',
  'adm.onb.doneClose': 'Selesai, tutup senarai ini', 'adm.onb.doneLater': 'Nanti sahaja',
  'adm.onb.hideForever': 'Sembunyikan selamanya',
  'adm.onb.step.guide': 'Baca panduan ringkas', 'adm.onb.step.guideDone': 'Sudah dibuka',
  'adm.onb.step.guideTodo': 'Mengandungi tangkapan skrin setiap langkah',
  'adm.onb.step.instructor': 'Tambah pakar pengajar',
  'adm.onb.step.instructorDone': '{n} pakar tersenarai',
  'adm.onb.step.instructorTodo': 'Kursus wajib mempunyai seorang pakar',
  'adm.onb.step.course': 'Buat kursus pertama', 'adm.onb.step.courseDone': '{n} kursus dibuat',
  'adm.onb.step.courseTodo': 'Mulakan dengan tajuk & pakar pengajarnya',
  'adm.onb.step.detail': 'Isi detail & objektif', 'adm.onb.step.detailDone': 'Penerangan & {n} objektif terisi',
  'adm.onb.step.syllabus': 'Susun silibus', 'adm.onb.step.price': 'Tetapkan harga atau percumakan',
  'adm.onb.step.priceTodo': 'Tentukan harga, atau tandakan percuma',
  'adm.onb.needCourse': 'Perlu satu kursus dahulu',
  'adm.onb.step.curatePlatform': 'Kurasi & terbitkan kursus',
  'adm.onb.curate.published': '{n} kursus tayang di katalog',
  'adm.onb.curate.waiting': '{n} kursus menunggu ditinjau',
  'adm.onb.curate.none': 'Belum ada kursus yang sedia ditinjau',
  'adm.onb.submit.published': 'Ada kursus yang sudah tayang',
  'adm.onb.submit.waiting': 'Sedang ditinjau admin platform',
  'adm.onb.submit.todo': 'Hantar kepada admin platform selepas kesediaan 4/4',

  // ---- pendapatan ----
  'adm.earn.col.order': 'Pesanan', 'adm.earn.col.share': 'Bahagian',
  'adm.earn.col.availableAt': 'Boleh cair',
  'adm.earn.paid': 'Sudah dibayar',

  // ---- siaran pemberitahuan ----
  'adm.bc.sub': 'Hantar pengumuman/pemberitahuan kepada audiens terpilih. Muncul pada loceng pemberitahuan pengguna.',
  'adm.bc.audience': 'Audiens', 'adm.bc.kind': 'Jenis',
  'adm.bc.aud.students': 'Semua peserta', 'adm.bc.aud.providers': 'Admin penyedia',
  'adm.bc.aud.admins': 'Admin platform', 'adm.bc.aud.all': 'Semua pengguna',
  'adm.bc.kind.announcement': 'Pengumuman', 'adm.bc.kind.promo': 'Promosi', 'adm.bc.kind.system': 'Sistem',
  'adm.bc.title': 'Tajuk', 'adm.bc.titlePh': 'cth. Kursus baharu: Tahsin Tahap 2 sudah tayang!',
  'adm.bc.body': 'Isi mesej', 'adm.bc.bodyPh': 'Tulis mesej ringkas & jelas…',
  'adm.bc.note': 'Dihantar serta-merta; tidak boleh ditarik balik.',
  'adm.bc.send': 'Hantar broadcast', 'adm.bc.sent': '{n} pemberitahuan dihantar',
  'adm.bc.failed': 'Gagal menghantar',
  'adm.bc.recent': 'Pemberitahuan terbaharu',
  'adm.bc.col.body': 'Isi', 'adm.bc.col.read': 'Dibaca',

  /* ---- akun pakar, direktori pakar & skala kategori ---- */
  'nav.profile': 'Profil Pakar',
  'nav.account': 'Akaun The Muslim', 'nav.language': 'Bahasa',
  'nav.instructors': 'Pakar',
  'acc.title': 'Akaun Saya',
  'acc.sub': 'Urus profil awam dan keselamatan akaun anda.',
  'acc.tab.profile': 'Profil Pakar',
  'acc.tab.security': 'Keselamatan',
  'acc.save': 'Simpan profil',
  'acc.saved': 'Profil disimpan',
  'acc.readonlyNote': 'Diurus admin. Hubungi admin lembaga untuk mengubahnya.',
  'acc.noProfile': 'Tiada profil pakar untuk akaun ini',
  'acc.noProfileHint': 'Hubungi admin lembaga anda untuk memautkannya.',
  'acc.field.avatar': 'Foto profil',
  'acc.field.headline': 'Tajuk ringkas',
  'acc.field.headlineHint': 'Satu baris bidang kepakaran anda. Maks. 160 aksara.',
  'acc.field.bio': 'Bio',
  'acc.field.bioHint': 'Latar belakang, penyelidikan dan pengalaman anda. Maks. 4000 aksara.',
  'acc.field.social': 'Pautan',
  'acc.field.socialHint': 'Mesti bermula dengan https://',
  'acc.social.linkedin': 'LinkedIn',
  'acc.social.web': 'Laman web',
  'acc.social.scholar': 'Google Scholar',
  'acc.social.youtube': 'YouTube',
  'acc.social.instagram': 'Instagram',
  'acc.social.x': 'X',
  'acc.field.credentials': 'Kelayakan',
  'acc.cred.title': 'Tajuk',
  'acc.cred.issuer': 'Pengeluar / butiran',
  'acc.cred.year': 'Tahun',
  'acc.cred.add': 'Tambah kelayakan',
  'acc.cred.remove': 'Buang',
  'acc.cred.empty': 'Belum ada kelayakan.',
  'acc.readonly.name': 'Nama',
  'acc.readonly.category': 'Bidang',
  'acc.readonly.provider': 'Lembaga',
  'acc.complete.title': 'Kelengkapan profil',
  'acc.complete.sub': 'Lengkapkan semua bahagian supaya profil anda sedia disahkan admin.',
  'acc.complete.count': '{n} daripada {total} selesai',
  'acc.pw.title': 'Keselamatan akaun',
  'acc.pw.sub': 'Kata laluan, e-mel dan nama anda diuruskan di The Muslim — satu akaun untuk semua perkhidmatan.',
  'acc.pw.manage': 'Urus akaun The Muslim',
  'acc.pw.unavailable': 'Alamat akaun The Muslim belum dikonfigurasikan di pelayan ini.',
  'adm.role.instructor': 'Pakar',
  'adm.role.student': 'Pelajar',
  'adm.gate.instructorSub': 'Akaun pakar tiada akses ke portal admin. Urus profil anda di halaman Akaun Saya.',
  'adm.gate.instructorCta': 'Ke profil saya',
  'ins.new': 'Pakar baharu',
  'ins.stat.rating': 'Penilaian',
  'ins.stat.students': 'Pelajar',
  'ins.stat.courses': 'Kelas',
  'ins.stat.answered': 'Q&A dijawab',
  'ins.coursesBy': 'Kelas oleh {name}',
  'ins.noCourses': 'Belum ada kelas',
  'ins.noCoursesHint': 'Pakar ini belum menerbitkan kelas.',
  'ins.noSlots': 'Belum ada jadual konsultasi.',
  'ins.consultSub': 'Sesi peribadi melalui panggilan video.',
  'insList.title': 'Pakar',
  'insList.sub': '{n} pakar terkurasi merentas bidang.',
  'insList.search': 'Cari nama atau kepakaran…',
  'insList.allCategories': 'Semua bidang',
  'insList.empty': 'Pakar tidak dijumpai',
  'insList.emptyHint': 'Cuba kata kunci lain atau tukar bidang.',
  'home.categoriesSub': '{n} bidang, satu piawaian kurasi.',
  'cat.courseCount': '{n} kelas',
  'cat.filterSearch': 'Cari bidang…',
  'cat.none': 'Bidang tidak dijumpai',
  'cat.seeAllExperts': 'Lihat semua pakar',

  // ——— kredit, bagi hasil, video pelajaran, ruang kerja pakar ———
  'vid.title': 'Video pelajaran',
  'vid.none': 'Belum ada video',
  'vid.upload': 'Muat naik video',
  'vid.dropHint': 'seret fail MP4 ke sini',
  'vid.choose': 'Pilih fail',
  'vid.replace': 'Ganti video',
  'vid.remove': 'Buang video',
  'vid.uploading': 'Memuat naik… {pct}%',
  'vid.finishing': 'Menyelesaikan…',
  'vid.ready': 'Video sedia',
  'vid.failed': 'Muat naik gagal',
  'vid.retry': 'Cuba lagi',
  'vid.cancel': 'Batal',
  'vid.tooLarge': 'Saiz video maksimum 2 GB.',
  'vid.wrongType': 'Hanya fail MP4 disokong.',
  'vid.slowStart': 'Video ini akan lambat bermula. Eksport semula dengan pilihan "faststart" supaya penonton tidak menunggu.',
  'vid.durationMin': '{n} minit',
  'vid.preview': 'Main pratonton',
  'vid.keepTab': 'Jangan tutup tab ini sehingga muat naik selesai.',
  'vid.onlyVideoLesson': 'Muat naik video hanya untuk pelajaran jenis Video.',
  'price.credits': 'Harga (kredit)',
  'price.creditsHint': 'Harga yang dibayar pelajar, dalam kredit.',
  'price.compareCredits': 'Harga asal (kredit)',
  'price.locked': 'Harga dikunci',
  'price.lockedHint': 'Harga tidak boleh diubah selepas kelas dihantar atau diterbitkan. Hubungi admin jika perlu.',
  'price.creditUnit': 'kredit',
  'cur.submit': 'Hantar untuk kurasi',
  'cur.submitting': 'Menghantar…',
  'cur.ready': 'Sedia dihantar',
  'cur.notReady': 'Belum sedia dihantar',
  'cur.problems': 'Apa yang masih kurang',
  'cur.waiting': 'Menunggu kurasi admin',
  'cur.rejectedReason': 'Sebab dikembalikan',
  'cur.fixAndResubmit': 'Betulkan, kemudian hantar semula.',
  'pd.title': 'Ruang kerja pakar',
  'pd.cardCourses': 'Kelas saya',
  'pd.cardStudents': 'Pelajar',
  'pd.cardCuration': 'Kurasi',
  'pd.published': '{n} diterbitkan',
  'pd.draftCount': '{n} draf',
  'pd.pendingCount': '{n} menunggu',
  'pd.rejectedCount': '{n} dikembalikan',
  'pd.activeStudents': '{n} aktif',
  'pd.completedStudents': '{n} selesai',
  'pd.needsAttention': 'Perlu tindakan',
  'pd.allGood': 'Tiada yang perlu dibetulkan.',
  'pd.recentStudents': 'Pelajar terbaru',
  'pd.noStudents': 'Belum ada pelajar.',
  'pd.privacyNote': 'Anda melihat nama dan foto sahaja. Maklumat hubungan pelajar tidak dikongsi.',
  'pd.myCourses': 'Kelas saya',
  'pd.newCourse': 'Cipta kelas',
  'pd.reorder': 'Susun urutan',
  'pd.noCourses': 'Belum ada kelas',
  'pd.noCoursesHint': 'Mulakan dengan mencipta kelas pertama anda.',
  'pd.videoReady': '{a}/{b} video sedia',
  'pd.reason.no_lessons': 'Belum ada pelajaran',
  'pd.reason.missing_video': 'Ada pelajaran video tanpa video',
  'pd.reason.no_price': 'Harga belum ditetapkan',
  'pd.reason.rejected': 'Dikembalikan oleh admin',
  'pd.reason.draft_stale': 'Draf lama belum dihantar',
  'wal.title': 'Dompet kredit',
  'wal.balance': 'Baki kredit',
  'wal.withdrawable': 'Boleh dikeluarkan',
  'wal.topup': 'Tambah kredit',
  'wal.history': 'Sejarah kredit',
  'wal.amount': 'Jumlah kredit',
  'wal.willPay': 'Yang dibayar',
  'wal.create': 'Cipta bil',
  'wal.manualNote': 'Selepas anda membayar, admin mengesahkan dan kredit masuk ke dompet.',
  'wal.empty': 'Belum ada transaksi.',
  'wal.topupsTitle': 'Bil tambah kredit',
  'wal.capNote': 'Hanya kredit komisen boleh dikeluarkan sebagai wang. Kredit tambahan digunakan untuk membeli kelas.',
  'wal.kind.topup': 'Tambah kredit',
  'wal.kind.purchase': 'Pembelian kelas',
  'wal.kind.commission': 'Komisen',
  'wal.kind.withdrawal': 'Pengeluaran',
  'wal.kind.adjustment': 'Pelarasan',
  'wal.kind.withdrawal_reversal': 'Pengeluaran dikembalikan',
  'wal.status.pending': 'Menunggu pembayaran',
  'wal.status.paid': 'Dibayar',
  'wal.status.failed': 'Gagal',
  'wal.status.expired': 'Luput',
  'wal.currency': 'Tambah kredit guna',
  'wal.payWith': 'Penyedia pembayaran',
  'wal.channel': 'Bayar guna',
  'wal.suggested': 'Disyorkan',
  'wal.noGateway': 'Belum ada cara pembayaran yang aktif. Sila hubungi admin.',
  'wal.minimum': 'Minimum bagi cara ini:',
  'wal.continuePay': 'Teruskan bayaran',
  'wal.gw.stripe': 'Kad kredit / debit',
  'wal.gw.doku': 'QRIS, pindahan & e-dompet',
  'wal.gw.manual': 'Pindahan manual',
  'wal.gwHint.stripe': 'Visa, Mastercard. Dicaj dalam ringgit (MYR).',
  'wal.gwHint.doku': 'QRIS, virtual account, OVO, DANA. Dicaj dalam rupiah (IDR).',
  'wal.gwHint.manual': 'Pindahan terus, disahkan oleh admin.',
  'wal.ret.checking': 'Pembayaran anda sedang disemak. Kredit masuk secara automatik selepas penyedia mengesahkan — biasanya kurang seminit.',
  'wal.ret.paid': 'Pembayaran diterima. Kredit sudah masuk ke dompet anda.',
  'wal.ret.cancelled': 'Pembayaran dibatalkan. Bilnya masih tersimpan dan boleh diteruskan dari senarai di bawah.',
  'wal.ret.failed': 'Pembayaran tidak berjaya. Tiada wang dipotong; sila cuba lagi.',
  'aff.title': 'Afiliasi',
  'aff.code': 'Kod anda',
  'aff.link': 'Pautan anda',
  'aff.copy': 'Salin',
  'aff.copied': 'Disalin',
  'aff.referred': 'Orang yang mendaftar',
  'aff.earned': 'Komisen diterima',
  'aff.pendingCredits': 'Menunggu pengeluaran',
  'aff.sales': 'Jualan',
  'aff.recent': 'Komisen terbaru',
  'aff.empty': 'Belum ada komisen.',
  'aff.hint': 'Kongsi pautan ini. Sesiapa yang mendaftar melaluinya terikat kekal dengan akaun anda.',
  'aff.permanentNote': 'Ikatan ini ditetapkan sekali dan tidak boleh diubah.',
  'wd.title': 'Pengeluaran',
  'wd.available': 'Boleh dikeluarkan',
  'wd.held': 'Dalam tempoh tahanan',
  'wd.feePct': 'Yuran {pct}%',
  'wd.net': 'Anda terima',
  'wd.request': 'Mohon pengeluaran',
  'wd.min': 'Minimum {n} kredit',
  'wd.method': 'Cara terima',
  'wd.methodPh': 'Contoh: pindahan bank kepada …',
  'wd.history': 'Sejarah pengeluaran',
  'wd.empty': 'Belum ada pengeluaran.',
  'wd.sent': 'Permohonan pengeluaran dihantar',
  'wd.holdNote': 'Komisen boleh dikeluarkan selepas tempoh tahanan. Ini melindungi daripada pembalikan bayaran.',
  'wd.status.requested': 'Dimohon',
  'wd.status.approved': 'Diluluskan',
  'wd.status.paid': 'Telah dibayar',
  'wd.status.rejected': 'Ditolak',
  'wd.source.instructor': 'Komisen mengajar',
  'wd.source.affiliate': 'Komisen afiliasi',
  'wd.source.provider': 'Komisen institusi',
  'co.payWithCredits': 'Bayar dengan kredit',
  'co.yourBalance': 'Baki anda',
  'co.creditWallet': 'Dompet kredit',
  'co.creditWalletNote': 'Baki dan tambah nilai diuruskan dalam akaun The Muslim anda.',
  'co.short': 'Kurang {n} kredit',
  'co.topupFirst': 'Tambah kredit dahulu',
  'co.paying': 'Memproses…',
  'ams.title': 'Tetapan wang',
  'ams.rate': 'Kadar 1 kredit',
  'ams.currency': 'Mata wang',
  'ams.split': 'Perkongsian hasil',
  'ams.platform': 'The Muslim',
  'ams.provider': 'Penyedia',
  'ams.instructor': 'Pakar',
  'ams.affiliate': 'Afiliat',
  'ams.mustBe100': 'Jumlah mesti tepat 100%.',
  'ams.total': 'Jumlah {n}%',
  'ams.withdrawFee': 'Yuran pengeluaran (%)',
  'ams.withdrawMin': 'Minimum pengeluaran (kredit)',
  'ams.hold': 'Tempoh tahanan (hari)',
  'ams.vat': 'VAT',
  'ams.vatOn': 'Aktifkan VAT',
  'ams.vatPct': 'Kadar VAT (%)',
  'ams.vatPoint': 'Titik kutipan',
  'ams.vatPoint.topup': 'Semasa tambah kredit',
  'ams.vatPoint.purchase': 'Semasa beli kelas',
  'ams.vatWarn': 'VAT masih dimatikan. Aktifkan hanya selepas kadar dan titik kutipan disahkan.',
  'ams.topupFee': 'Yuran tambah kredit (%)',
  'ams.topupFeeFlat': 'Yuran tetap tambah kredit',
  'ams.example': 'Contoh pembelian 10 kredit',
  'ams.saved': 'Tetapan wang disimpan',
  'ams.ch.tab': 'Cara bayar',
  'ams.ch.name': 'Cara bayar',
  'ams.ch.gateway': 'Penyedia',
  'ams.ch.feeBps': 'Kadar (bps)',
  'ams.ch.feeFlat': 'Yuran tetap',
  'ams.ch.vat': 'Cukai (bps)',
  'ams.ch.effective': 'Berkuat kuasa',
  'ams.ch.on': 'Aktif',
  'ams.ch.off': 'Tidak aktif',
  'ams.ch.noCode': 'Tiada kod penyedia',
  'ams.ch.empty': 'Belum ada cara bayar.',
  'ams.gross': 'Kasar',
  'ams.fee': 'Yuran penyedia',
  'ams.net': 'Bersih diterima',
  'ams.markPaid': 'Tanda dibayar',
  'ams.payNow': 'Bayar',
  'ams.rejectWd': 'Tolak',
  'nav.wallet': 'Dompet',
  'nav.affiliate': 'Afiliasi',
  'admin.myCourses': 'Kelas Saya',
  'admin.money': 'Tetapan Wang',
  'admin.topups': 'Tambah Kredit',
  'admin.withdrawals': 'Pengeluaran',
  'admin.workspaceOnly': 'Ruang kerja pakar',
  'adm.gate.instructorCta': 'Ke ruang kerja saya',
  'aff.haveCode': 'Ada kod afiliat?',
  'aff.enterCode': 'Masukkan kod',
  'aff.apply': 'Guna',
  'aff.applied': 'Afiliat ditetapkan',
  'aff.onlyBefore': 'Kod hanya boleh ditetapkan sebelum pembelian pertama.',
  'aff.myReferrer': 'Afiliat anda sudah ditetapkan.',

  // ---- kredit: dasbor + buku besar bagi hasil ----
  'adm.dash.creditsMonth': 'Kredit masuk bulan ini',
  'adm.dash.credits12': 'Kredit 12 bulan',
  'adm.dash.credits12sub': 'Pesanan lunas, setiap bulan',
  'adm.earn.sub': 'Lejar bagi-hasil, satu baris bagi setiap penerima. Semua nilai dalam kredit.',
  'adm.earn.total': 'Jumlah kredit',
  'adm.earn.col.payee': 'Penerima',
  'adm.earn.col.credits': 'Kredit',
  'adm.earn.col.payeeType': 'Peranan',
  'adm.earn.payee.platform': 'Platform',
  'adm.earn.payee.provider': 'Penyedia',
  'adm.earn.payee.instructor': 'Pakar',
  'adm.earn.payee.affiliate': 'Afiliat',
  'adm.earn.legacy': '{n} baris rupiah warisan tidak dijumlahkan.',
  'adm.earn.unclaimed': 'Belum dituntut',
  // Prasyarat & laluan pembelajaran (§21).
  'course.prereqLocked': 'Selesaikan kursus ini dahulu:',
  'course.prereqAdvised': 'Disyorkan selesaikan dahulu:',
  'course.prereqGo': 'Buka kursus prasyarat',
  'course.path': 'Laluan pembelajaran',
  'course.pathHint': 'Susunan yang disyorkan pengajar.',
  'course.pathBefore': 'Sebelum ini',
  'course.pathNow': 'Kursus ini',
  'course.pathNext': 'Seterusnya',
  'adm.course.prereq': 'Kursus prasyarat',
  'adm.course.prereqNone': 'Tiada prasyarat',
  'adm.course.prereqHint': 'Kursus yang patut diselesaikan dahulu. Kursus anda sahaja.',
  'adm.course.prereqRequired': 'Wajib selesai dahulu',
  'adm.course.prereqLocked': 'Pelajar tidak boleh membeli kursus ini sebelum lulus prasyarat.',
  'adm.course.prereqAdvised': 'Dipaparkan sebagai saranan sahaja. Kursus tetap boleh dibeli.',
  'course.payNote': 'Dibayar dengan kredit · akses terbuka serta-merta',
  'adm.coupons.field.valueCredits': 'Potongan tetap (kredit)',
  'adm.coupons.field.valueCreditsHint': "Hanya digunakan apabila jenis kupon 'fixed'. Untuk 'percent', isi medan Nilai.",

  // --- Pemberitahuan e-mel kurasi ---
  'adm.bc.tab.send': 'Hantar siaran',
  'adm.bc.tab.email': 'E-mel automatik',
  'adm.notif.smtp': 'Penghantaran e-mel',
  'adm.notif.smtpOn': 'Sedia',
  'adm.notif.smtpOff': 'Belum ditetapkan',
  'adm.notif.smtpFrom': 'Dihantar daripada {from}',
  'adm.notif.smtpHint': 'Kelayakan SMTP belum diisi pada pelayan, jadi e-mel tidak akan dihantar walaupun senarai di bawah sudah diisi. Isikan SMTP_HOST dan SMTP_FROM dalam fail .env pelayan.',
  'adm.notif.curation': 'Beritahu melalui e-mel apabila ada kelas dihantar untuk kurasi',
  'adm.notif.curationHint': 'Pemberitahuan dalam panel tetap dibuat walaupun ini dimatikan. Yang ini menambah e-mel, supaya barisan kurasi tidak bertimbun hanya kerana tiada sesiapa membuka panel.',
  'adm.notif.recipients': 'Alamat penerima',
  'adm.notif.addEmail': 'Tambah alamat',
  'adm.notif.removeEmail': 'Buang alamat',
  'adm.notif.noRecipients': 'Belum ada alamat. Tanpa seorang pun penerima, tiada e-mel yang boleh dihantar.',
  'adm.notif.decision': 'Beritahu pakar apabila kelasnya diluluskan atau ditolak',
  'adm.notif.decisionHint': 'Dihantar ke e-mel akaun pakar pemilik kelas. Bagi yang ditolak, sebabnya turut disertakan.',
  'adm.notif.save': 'Simpan tetapan',
  'adm.notif.test': 'Hantar e-mel percubaan',
  'adm.notif.testSent': 'E-mel percubaan dihantar ke {n} alamat.',
  'adm.notif.testFailed': 'E-mel percubaan gagal dihantar.',
}
